import React from 'react'
import styled from 'styled-components'
import { color, typography, layout, space, variant } from 'styled-system'

const Images = styled.img`
  ${typography}
  ${color}
  ${space}
  ${layout}
  ${variant({
    variants: {
      shadow: {
        paddingTop: '100px',
      },
      toDark: {
        filter: 'brightness(0.2)'
      },
      whiteToPrimary: {
        filter: 'invert(67%) sepia(39%) saturate(654%) hue-rotate(35deg) brightness(1.9) contrast(94%)',
      }
    },
  })}
`

const Image = ({ image, children, tag, ...props }) => (
  <Images {...props} as={tag} src={image}/>
)

Images.defaultProps = {
  mb: 0,
}

export default Image

